/**
 * Положен ли игроку разовый анонс ежедневной «Битвы с AI Claude Opus» в
 * главном меню (см. AiMatchNewsModal): только вошедшему игроку, которому
 * промо открыто (признак isAiPromoAvailable из профиля — сервер учитывает,
 * включено ли промо и не идет ли пилот только для админов), и только пока он
 * анонс не закрыл. Признак показа приходит с сервером: null — неизвестно
 * (путь профиля его не прислал), и тогда анонс не показывается.
 *
 * Очередь модалок меню решает само меню (checkIfAiMatchNewsOpenable).
 *
 * @param {Object} params
 * @param {string|null} [params.userId]
 * @param {boolean} [params.isGuest]
 * @param {boolean} [params.isAiPromoAvailable]
 * @param {boolean|null} [params.hasSeenAiMatchNews]
 * @returns {boolean}
 */
export const checkIfAiMatchNewsDue = ({
  userId,
  isGuest,
  isAiPromoAvailable,
  hasSeenAiMatchNews,
}) => Boolean(userId)
  && !isGuest
  && isAiPromoAvailable === true
  && hasSeenAiMatchNews === false;
